<template>
  <ValidationObserver ref="wizardPage6" id="wizardPage6" name="wizardPage6">
    <div>
      <div v-if="appData && appData.policy && appData.client && appData.transaction && appData.documents && appData.quotes">

        <div v-if="!appData.uwApprovalsDataValid">
          <span class="text-danger font-weight-bold">Invalid UW-Approvals - Please click on 'Refresh Approvals' button on the previous page to get the latest data.</span>
        </div>
        <div v-if="!uwApprovalsCompleted">
          <span class="text-danger font-weight-bold">All UW-Approvals must be completed before proceeding further.</span>
        </div>
        <div v-if="!granularClaimsHistoryValid">
          <span class="text-danger font-weight-bold">Granular claims history must be fixed before proceeding further.</span>
        </div>

        <!-- UW Approvals Validation -->
        <ValidationProvider :rules="{ 'required': { allowFalse: false }}" name="uwApprovalsCompleted" v-slot="{ errors }">
          <input type="checkbox" hidden="hidden" class="form-control" v-model="uwApprovalsCompleted"/>
          <span class="text-danger font-weight-bold">{{ errors[0] ? 'All Approvals must be completed before proceeding further.' : '' }}</span>
        </ValidationProvider>
        <br/>
        <ValidationProvider :rules="{ 'required': { allowFalse: false }}" name="uwApprovalsDataValid" v-slot="{ errors }">
          <input type="checkbox" hidden="hidden" class="form-control" v-model="appData.uwApprovalsDataValid"/>
          <span class="text-danger font-weight-bold">{{ errors[0] ? 'Invalid approvals data - Please click on \'Refresh Approvals\' button to get the latest data.' : '' }}</span>
        </ValidationProvider>

        <!-- Granular Claims History Validation -->
        <ValidationProvider :rules="{ 'required': { allowFalse: false }}" name="granularClaimsHistoryValid" v-slot="{ errors }">
          <input type="checkbox" hidden="hidden" class="form-control" v-model="granularClaimsHistoryValid"/>
          <span class="text-danger font-weight-bold">{{ errors[0] }}</span>
        </ValidationProvider>

        <div v-if="appData.uwApprovalsDataValid && uwApprovalsCompleted && granularClaimsHistoryValid">
          <h3 class="font-weight-bold text-dark">
            Select Quotes for Document
          </h3>
          <div class="col-6 mb-10">
            <table class="table table-sm table-bordered">
              <thead>
              <th width="30%" class="text-center">Excess</th>
              <th width="30%" class="text-center">Base Premium</th>
              <th width="20%" class="text-center">Recommended Quote</th>
              <th width="20%" class="text-center">Include in Document</th>
              </thead>

              <tr v-for="(quote, index) in appData.quotes" :key="index">
                <td class="text-center" style="vertical-align: middle;">
                  {{ Number(quote.K_Excess) | currency }}
                </td>
                <td class="text-center" style="vertical-align: middle;">
                  {{ Number(quote.K_BasePremium) | currency }}
                </td>
                <td class="text-center">
                  <input type="radio" name="K_RecommendedQuote" v-model="quote.K_RecommendedQuote" :value="true"
                         @input="setRecommended(quote)" :disabled="isReadOnly || appData.quoteDocumentSent">
                </td>
                <td class="text-center">
                  <input type="checkbox" v-model="quote.K_SelectedForDocument"
                         :disabled="isReadOnly || quote.K_RecommendedQuote || appData.quoteDocumentSent">
                </td>
              </tr>
            </table>
          </div>

          <Document
              document-name="Quote Document"
              :document="appData.documents.quoteDocument" :processing="uiQuoteDocument.processing"
              :on-create-document="createQuoteDocument" :is-read-only="isReadOnly"
          />

          <div v-if="appData.documents.quoteDocument">
            <br />
            <h3 class="font-weight-bold text-dark mb-2 mt-5">
              Send Quote to Client
            </h3>
            <div class="row">
            <span class="switch switch-sm switch-outline switch-icon switch-primary ml-4">
              <label>
                <input type="checkbox" name="select" v-model="appData.quoteDocumentSent" :disabled="isReadOnly || !uwApprovalsCompleted || !appData.uwApprovalsDataValid"/>
                <span></span>
              </label>
            </span>
              <label class="col-form-label font-size-h5 ml-2">I confirm that the quote document has been sent to the client.</label>
            </div>
            <br />
          </div>

          <div v-if="!isReadOnly && appData.quoteDocumentSent">
            <h3 class="font-weight-bold text-dark mb-2 mt-5">
              Finalisation
            </h3>
            <strong>
              Choose one of the options below and enter the required information. Then click the green
              <b>Bind Cover</b> button in the wizard footer (bottom of the page) — not on the Processing step.
            </strong>
            <br /><br />

            <b-form-radio-group v-model="tempOutcome" name="quoteDecision" class="form-control mb-5 mt-3" size="lg" @change="setOutcome">
              <b-form-radio :value="outcomes.acceptedByClient">Accepted by Client</b-form-radio>
              <b-form-radio class="ml-10" :value="outcomes.rejectedByClient">Rejected by Client</b-form-radio>
            </b-form-radio-group>

            <div v-if="outcome === outcomes.acceptedByClient">
              <div v-if="fleetIncomplete" class="mt-5 mb-5 text-danger font-size-h5">
                <strong>Missing fleet information must be completed before binding the cover. Please check the Fleet page.</strong>
              </div>

              <div v-if="!fleetIncomplete">
                <h5 class="font-weight-bold text-dark mt-8">
                  Select Accepted Quote
                </h5>
                <div class="col-6 mb-10">
                  <table class="table table-sm table-bordered">
                    <thead>
                    <th width="30%" class="text-center">Excess</th>
                    <th width="30%" class="text-center">Base Premium</th>
                    <th width="20%" class="text-center">Accepted Quote</th>
                    </thead>

                    <tr v-for="(quote, index) in appData.quotes" :key="index">
                      <td class="text-center" style="vertical-align: middle;">
                        {{ Number(quote.K_Excess) | currency }}
                      </td>
                      <td class="text-center" style="vertical-align: middle;">
                        {{ Number(quote.K_BasePremium) | currency }}
                      </td>
                      <td class="text-center">
                        <input type="radio" name="K_AcceptedQuote" v-model="quote.K_QuoteStatus" value="Accepted"
                               @input="setRecommended(quote)" :disabled="isReadOnly">
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-3 col-form-label text-right">Policy Number</label>
                  <div class="col-3 font-weight-bold col-form-label">
                    {{ appData.policy.K_PolicyNumber }}
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-3 col-form-label text-right">iBais Client Number</label>
                  <div class="col-3 font-weight-bold col-form-label">
                    {{ appData.client.K_IbaisClientNumber }}
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-3 col-form-label text-right">Insurance Start Date</label>
                  <div class="col-3 font-weight-bold col-form-label">
                    {{ appData.transaction.K_ProposedStartDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-3 col-form-label text-right">Insurance End Date</label>
                  <div class="col-3 font-weight-bold col-form-label">
                    {{ appData.transaction.K_ProposedEndDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-3 col-form-label text-right font-weight-bold font-size-h6">
                    Enter iBais Memo Number
                  </label>
                  <div class="col-3">
                    <input type="text" size="255" class="form-control text-uppercase" v-model="tempIbaisMemoNumber"
                           @input="setMemoNumber" :disabled="isRenewalTransaction && ibaisMemoNumber"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div v-if="outcome === outcomes.rejectedByClient">
              <div class="form-group row mb-0">
                <div class="col-12">
                  <label class="col-form-label font-weight-bold font-size-h6">Enter Rejection Reason</label>
                  <b-form-textarea class="form-control" size="2000" rows="3" max-rows="6" v-model="appData.transaction.K_Reason" :disabled="isReadOnly"/>
                </div>
              </div>
            </div>

            <div class="mt-8" v-if="!isReadOnly">
              <button
                class="btn btn-success font-weight-bold text-uppercase px-9 py-4"
                @click.prevent="$emit('bind-cover')"
              >
                Bind Cover
              </button>
              <div class="text-muted mt-2 font-size-sm">
                Sets Status back to Completed after Reopen / rekey. Then use Processing → Stamp.
              </div>
            </div>
          </div>
        </div>

        <div v-if="isReadOnly">
          <h3 class="font-weight-bold text-dark mb-5 mt-10">
            {{ appData.transaction.K_Type }}&nbsp;Transaction Finalised With Outcome - <b-badge variant="primary">{{ outcome }}</b-badge>
          </h3>

          <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header-class="p-3 font-size-lg font-weight-bold">
            <!-- Transaction accepted by client - show policy details -->
            <div v-if="outcome === outcomes.acceptedByClient">
              <b-card-text>
                <strong>Details of the finalised transaction are below.</strong>
              </b-card-text>
              <div class="form-group row mb-0 mt-2">
                <label class="col-3 col-form-label text-right">
                  Insurance Start Date
                </label>
                <div class="col-3 font-weight-bold col-form-label">
                  {{ appData.transaction.K_ProposedStartDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                </div>
                <label class="col-3 col-form-label text-right">Total Annual Premium</label>
                <div class="col-3 font-weight-bold col-form-label">
                  {{ appData.transaction.K_TotalAnnualPremium | currency }}
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-3 col-form-label text-right">Insurance End Date</label>
                <div class="col-3 font-weight-bold col-form-label">
                  {{ appData.transaction.K_ProposedEndDate | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                </div>

                <label class="col-3 col-form-label text-right">Excess</label>
                <div class="col-3 font-weight-bold col-form-label" v-if="appData.transaction.K_Excess">
                  {{ Number(appData.transaction.K_Excess) | currency}}
                </div>
              </div>

              <div class="form-group row mb-0">
                <label class="col-3 col-form-label text-right">Premium Type</label>
                <div class="col-3 font-weight-bold col-form-label">
                  {{ appData.transaction.K_PaymentMethod }}
                </div>
              </div>
            </div>

            <!-- Transaction rejected by client - show reason -->
            <div v-if="outcome === outcomes.rejectedByClient || outcome === outcomes.declinedByInsurer">
              <b-card-text><strong>Outcome : {{ outcome }}</strong></b-card-text>
              <div class="form-group row mb-0">
                <div class="col-12">
                  <label class="col-form-label font-weight-bold font-size-h6">Reason</label>
                  <b-form-textarea class="form-control" size="2000" rows="3" max-rows="6" v-model="appData.transaction.K_Reason" disabled/>
                </div>
              </div>
            </div>

          </b-card>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>
import _ from "lodash";
import Document from "@/view/pages/wizard/newbusiness-renewal/components/Document.vue";

export default {
  name: "FinalisationPage",
  components: { Document },
  props: {
    appData: Object,
    outcome: String,
    isReadOnly: Boolean,
    ibaisMemoNumber: String
  },

  data() {
    return {
      tempIbaisMemoNumber: this.ibaisMemoNumber,
      tempOutcome: this.outcome,

      uiQuoteDocument: {
        docType: "quoteDocument",
        docgenDocType: "QUOTATION",
        processing: false,
      },

      outcomes: {
        acceptedByClient: "Accepted by Client",
        rejectedByClient: "Rejected by Client",
        declinedByInsurer: "Declined by Insurer",
      },
    };
  },

  watch: {
    ibaisMemoNumber: function(newVal /*, oldVal*/) {
      this.tempIbaisMemoNumber = newVal;
    }
  },

  computed: {
    isRenewalTransaction: function () {
      if(this.appData) {
        let txnType = _.get(this.appData, 'transaction.K_Type');
        return txnType === "Renewal";
      }
      return false;
    },

    uwApprovalsCompleted: function() {
      if(this.appData) {
        const approvals = this.appData.uwApprovals;
        if(Array.isArray(approvals) && approvals.length > 0) {
          return !_.some(approvals, approval => {
            return approval.K_ApprovalStatus !== 'Approved';
          })
        }
        else {
          return true;
        }
      }
      return false;
    },

    recommendedQuoteExists: function () {
      const quotes = _.get(this.appData, 'quotes');
      if(Array.isArray(quotes) && quotes.length > 0) {
        return _.some(quotes, { 'K_RecommendedQuote': true });
      }
      return false;
    },

    fleetIncomplete: function () {
      if(this.appData) {
        return this.appData.fleetInfo.incompleteCount > 0;
      }
      return true;
    },

    granularClaimsHistoryValid: function () {
      if(this.appData?.transaction?.K_ClaimsHistoryInputMethod === 'Granular Claims Data') {
        return this.appData.claimsHistoryInfo?.claimsHistoryUploaded
            && !this.appData.claimsHistoryInfo?.K_ClaimsHistoryInvalid;
      }
      return true;
    }
  },

  methods: {
    setRecommended: function (quote) {
      for(const q of this.appData.quotes) {
        if(quote.id === q.id) {
          q.K_RecommendedQuote = true;
          q.K_SelectedForDocument = true;
        }
        else {
          q.K_RecommendedQuote = false;
        }
      }
    },

    setOutcome: function() {
      this.$emit('setOutcome', this.tempOutcome);
    },

    setMemoNumber: function() {
      this.$emit('setMemoNumber', this.tempIbaisMemoNumber);
    },

    createQuoteDocument: function () {
      if(!this.recommendedQuoteExists) {
        this.$emit('handleError', 'Please select the recommended quote.');
        return;
      }
      this.$emit('createQuoteDocument', this.uiQuoteDocument);
    },

    getIbaisInclusionsText: function () {
      this.$emit('getIbaisInclusionsText');
    }
  }
};
</script>
